module.exports = __webpack_public_path__ + "static/media/DownloadSelectedDeliveries.ba07f982.svg";